/**
 * アクセシビリティ関連の共通表示定数
 */

/**
 * 入力プレースホルダー色
 * #FFFDF0 背景に対して4.85:1のコントラスト比を確保します。
 */
export const INPUT_PLACEHOLDER_COLOR = '#68717B';

/** 既存・並列実装向けの同義名 */
export const ACCESSIBLE_PLACEHOLDER_TEXT_COLOR = INPUT_PLACEHOLDER_COLOR;
